import ArrowIcon from '../../../assets/svg/catalog-right.svg?react';
import styles from './FJMoreButton.module.less';
import PropTypes from 'prop-types';
const FJMoreButton = props => {
    let { boxStyle, onClick } = props;
    return (
        <div className={styles.box} style={boxStyle} onClick={onClick}>
            <div className={styles.arrow_button}>
                <ArrowIcon />
            </div>
        </div>
    );
};
FJMoreButton.propTypes = {
    boxStyle: PropTypes.object,
    onClick: PropTypes.func,
};
export default FJMoreButton;
